/**
 * Admin copy for W6-SESSION-ACTORS (D397): the signed-in operator is every actor, so the food-onboarding review names
 * the operator deciding, explains the four-eyes refusals by their reason code, and labels a record written before
 * actors came from the session. Kept in its own file; `messages.ts` spreads it into the catalog and asserts no id
 * collides. Same four base languages.
 */
type SessionActorsEntry = Readonly<{ pt: string; en: string; es: string; it: string }>;

export const SESSION_ACTORS_DICT: Readonly<Record<string, SessionActorsEntry>> = {
  'actors.legacy.notice': {
    pt: 'Registro antigo: quem agiu nele antes da identificação por sessão foi informado pelo cliente, não pela sessão — esses nomes não são atestados.',
    en: 'Older record: who acted on it before session identity was stated by the client, not taken from the session — those names are not attested.',
    es: 'Registro antiguo: quién actuó en él antes de la identidad por sesión lo informó el cliente, no la sesión — esos nombres no están atestados.',
    it: 'Record precedente: chi ha agito prima dell’identità di sessione è stato indicato dal client, non dalla sessione — quei nomi non sono attestati.',
  },
  'foodReview.decide.asSession': {
    pt: 'Você decide como {id}. A segunda aprovação precisa de outro revisor, com a própria sessão.',
    en: 'You decide as {id}. A second approval needs another reviewer, signed in as themselves.',
    es: 'Decides como {id}. La segunda aprobación necesita otro revisor, con su propia sesión.',
    it: 'Decidi come {id}. La seconda approvazione richiede un altro revisore, con la propria sessione.',
  },
};
